import { components, paths } from "@api/api";
import { useSelector } from "react-redux";
import { currentCountrySelector } from "@selectors/countries.selector";
import useAxios from "@hooks/useFetch";

const REQUEST_URL: keyof paths = '/InstantCharts/{countryCode}';
export type InstantChartCategory = components["schemas"]["InstantChartCategoryModel"];

export function useInstantCharts() {
    const countryCode = useSelector(currentCountrySelector);

    const url = REQUEST_URL.replace('{countryCode}', countryCode ?? '');

    const { data, isLoading} = useAxios<InstantChartCategory[]>({
        url,
        method: 'get',
        lazy: !countryCode,
    });

    return {
        isLoading,
        data: data ?? [],
    };
}
